import { render, staticRenderFns } from "./RulesConfirmModal.vue?vue&type=template&id=6fbfb804&scoped=true"
import script from "./RulesConfirmModal.vue?vue&type=script&lang=js"
export * from "./RulesConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbfb804",
  null
  
)

export default component.exports